/**
 * The year filter the Trade Ops dashboards send.
 *
 * Extracted from `TradeOperationsLayout.fetchData` so that exactly one piece of
 * code computes these two strings. The offline pack has to capture the SAME
 * URL the screen will later ask for, and "two places that compute the same
 * thing" is how offline mode came to store `/api/deliveries/` while the screen
 * asked for `/api/deliveries/?start_date=2025-12-31T22:00:00.000Z&...` and got
 * an empty table with no error (2026-08-11).
 *
 * The values are deliberately unchanged from what shipped: LOCAL midnight on
 * 1 January, and the last millisecond of 31 December, each serialised with
 * `toISOString()`. That means they carry the browser's timezone offset — in
 * Johannesburg the 2026 range starts at `2025-12-31T22:00:00.000Z`. It looks
 * wrong and it is not: the backend filters on timezone-aware datetimes, so a
 * local-midnight boundary is the correct one for the user reading the screen.
 * It is, however, unpredictable server-side, which is why the pack captures
 * these from the browser (see `src/offline/clientVariants.js`) rather than from
 * `offline_pack/registry.py`.
 */

/**
 * @param {Date} date any date inside the year of interest
 * @returns {{year: number, startDate: string, endDate: string}}
 */
export function tradeOpsYearRange(date) {
  const year = date.getFullYear();

  const startOfYear = new Date(year, 0, 1);
  const endOfYear = new Date(year + 1, 0, 1);
  endOfYear.setMilliseconds(-1); // Last millisecond of December 31

  return {
    year,
    startDate: startOfYear.toISOString(),
    endDate: endOfYear.toISOString(),
  };
}

export default tradeOpsYearRange;
